import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, ShoppingCart, Search, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileWarehouseAllocatePage() {
  const navigate = useNavigate();
  const [lpNumber, setLpNumber] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [lpInfo, setLpInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allocating, setAllocating] = useState(false);
  const [success, setSuccess] = useState(false);

  const lookupLP = async () => {
    if (!lpNumber.trim()) return;
    setLoading(true);
    setLpInfo(null);
    try {
      const res = await axios.get(`${API}/warehouse/license-plates/${lpNumber.trim()}`);
      setLpInfo(res.data);
    } catch {
      toast.error('License plate not found');
    } finally {
      setLoading(false);
    }
  };

  const handleAllocate = async () => {
    if (!orderNumber.trim()) {
      toast.error('Enter an order number');
      return;
    }
    setAllocating(true);
    try {
      await axios.post(`${API}/warehouse/license-plates/${lpNumber.trim()}/allocate`, {
        order_number: orderNumber.trim()
      });
      setSuccess(true);
      toast.success(`Allocated ${lpNumber} to order ${orderNumber}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Allocation failed');
    } finally {
      setAllocating(false);
    }
  };

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/warehouse')}>
        <ArrowLeft size={18} /> Warehouse
      </button>

      <div className="mobile-page-title" style={{ marginBottom: 16 }}>Allocate to Order</div>

      {success ? (
        <div className="mobile-detail-section" style={{ textAlign: 'center', padding: 30 }}>
          <CheckCircle size={48} style={{ color: '#34c759', marginBottom: 12 }} />
          <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 6 }}>Allocated Successfully</div>
          <div style={{ color: '#8e8e93', marginBottom: 20 }}>{lpNumber} → Order {orderNumber}</div>
          <button className="mobile-action-btn primary" onClick={() => { setSuccess(false); setLpNumber(''); setOrderNumber(''); setLpInfo(null); }}>
            Allocate Another
          </button>
        </div>
      ) : (
        <>
          <div className="mobile-detail-section">
            <div className="mobile-input-group">
              <label className="mobile-input-label">License Plate Number</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="mobile-input" placeholder="LP-YYYYMMDD-XXXX" value={lpNumber} onChange={e => setLpNumber(e.target.value)} style={{ flex: 1 }} />
                <button className="mobile-action-btn primary" style={{ width: 'auto', padding: '12px 16px' }} onClick={lookupLP} disabled={loading}>
                  <Search size={18} />
                </button>
              </div>
            </div>

            {loading && <div className="mobile-loading"><div className="mobile-spinner" /></div>}

            {lpInfo && (
              <div style={{ marginTop: 12, padding: 12, background: '#f9f9fb', borderRadius: 10 }}>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{lpInfo.item_name || 'N/A'}</div>
                <div style={{ fontSize: 13, color: '#636366' }}>Lot: {lpInfo.lot_number || 'N/A'}</div>
                <div style={{ fontSize: 13, color: '#636366' }}>Qty: {lpInfo.quantity || lpInfo.quantity_on_hand || 'N/A'}</div>
                <div style={{ fontSize: 13, color: '#636366' }}>Status: {lpInfo.status}</div>
              </div>
            )}
          </div>

          {lpInfo && (
            <div className="mobile-detail-section">
              <div className="mobile-input-group">
                <label className="mobile-input-label">Order Number</label>
                <input className="mobile-input" placeholder="SO-XXXXX" value={orderNumber} onChange={e => setOrderNumber(e.target.value)} />
              </div>
              <button className="mobile-action-btn primary" onClick={handleAllocate} disabled={allocating}>
                <ShoppingCart size={18} />
                {allocating ? 'Allocating...' : 'Allocate'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
